import { useTranslation } from '@/shared/core/hooks/use-translation/use-translation.ts'
import { ScrollIndicator } from '@/teams/portfolio/components/scroll-indicator/scroll-indicator.tsx'
import { Section } from '@/teams/portfolio/components/section/section/section.tsx'
import '@/teams/portfolio/components/section/projects-section/projects-section.scss'

export function ProjectsSection() {
	const { t } = useTranslation()

	return (
		// biome-ignore lint/correctness/useUniqueElementIds: Static ID needed for URL anchor navigation
		<Section
			ariaLabel={t('portfolio.section.projects.ariaLabel')}
			id='projects'>
			<div className='projects-section'>
				<h2 className='projects-section__title'>
					{t('portfolio.section.projects.title')}
				</h2>
				<p className='projects-section__placeholder'>
					{t('portfolio.section.projects.placeholder')}
				</p>

				<ScrollIndicator targetSection='contact' />
			</div>
		</Section>
	)
}
